import { useMutation } from '@apollo/client';
import { graphql } from '../gql';
import { GET_QUOTES } from './quotes.query';
import { GET_RATER } from './rater.query';

export const CREATE_DEFAULT_QUOTE_MUTATION = graphql(`
  mutation createDefaultQuote(
    $submissionUuid: String!
    $convergePrimaryAggregateLimit: Int!
    $convergePrimaryPolicyRetention: Float!
    $insurerPrimaryLimit: Int
    $insurerPrimaryPremium: Float
    $insurerPrimaryRetention: Float
    $insurerPrimaryParticipantUuid: String
  ) {
    createDefaultQuote(
      convergePrimaryAggregateLimit: $convergePrimaryAggregateLimit
      convergePrimaryPolicyRetention: $convergePrimaryPolicyRetention
      insurerPrimaryLimit: $insurerPrimaryLimit
      insurerPrimaryPremium: $insurerPrimaryPremium
      insurerPrimaryRetention: $insurerPrimaryRetention
      insurerPrimaryParticipantUuid: $insurerPrimaryParticipantUuid
      submissionUuid: $submissionUuid
    ) {
      uuid
    }
  }
`);

export function useCreateDefaultQuoteMutation() {
  const [createDefaultQuote, { loading, error, reset, called, client, data }] =
    useMutation(CREATE_DEFAULT_QUOTE_MUTATION, {
      refetchQueries: [GET_QUOTES, GET_RATER],
    });

  return {
    createDefaultQuote,
    loading,
    error,
    reset,
    called,
    client,
    data,
  };
}
